const en = {
  home: "Home",
  logout: "Logout",
  fontsize: "Font size",
  oops404: "Ah!",
  info404: "Please check if the URL you entered is correct, or click the button below to return to the homepage.",
  returnhome404: "Return to homepage",
  errormsg404: "The webmaster said you cannot access this page...",
  login: {
    title: "Fault locating systems",
    accounttip: "Please enter account",
    passwordtip: "Please enter password",
    codetip: "Please enter Verification code",
    loginbt: "Login",
    pwderror: "The password cannot be less than 6 digits",
    codeerror: "The verification code entered is incorrect",
    logini: "Logging..."
  },
  spread: {
    faulttype: "Fault indicator",
    edgetype: "Marginal sub-stations",
    daysoe: "Today SOE",
    all: "All",
    null_value: "Null value",
    worth_it: "Worth it",
    not_upgraded: "Not upgraded",
    upgrading: "Upgrading",
    upgrade_uccessful: "Upgrade uccessful",
    upgrade_failed: "Upgrade failed",
    upgrade_nstructions: "Upgrade nstructions",
    upgrade_time: "Upgrade time",
    onlinetit: "Online",
    offlinetit: "Offline",
    faulttit: "Failure",
    devicetabletit: "Equipment information",
    notit: "False",
    yestit: "True",
    devicetab: {
      serial: "SN",
      linename: "Name of the line",
      devname: "Name of the device",
      terid: "Terminal ID",
      manu: "Manufacturer",
      tername: "Name of the terminal",
      devstate: "Equipment status",
      devtype: "Type of equipment",
      devmodel: "Equipment model",
      operat: "Operational or not",
      can_lb: "Record waves or not",
      pointtype: "Point table type",
      time: "Online time",
      Belonging: "Affilated feeder",
      position: "Installation position",
      Operationtime: "Operation time",
      longitude: "Longitude",
      latitude: "Latitude",
      desc: "Description",
      upttime: "Update time",
      heartbeat_time: "Online time",
      create_time: "Creation time"
    },
    lineeventtit: "Route events in recent 7 days",
    organizationtit: "List of regional organizations",
    alarmnotification: "SOE alarm notification",
    soealarmtab: {
      serial: "SN",
      circuit: "Circuit",
      alarmcontent: "Alarm content"
    },
    circuittit: "Circuit",
    zonetit: "Zone",
    content: "Content",
    detail: "Detail",
    cancellation: "Cancel",
    determine: "Confirm",
    soewarning: "Please select at least one message",
    soesuccess: "Confirmed notification"
  },
  detection: {
    line: {
      title: "Fault indicator system diagram",
      datatit: "No data at present"
    }
  },
  publics: {
    add: "Add",
    edit: "Edit",
    save: "Save",
    operation: "Operation",
    detail: "Details",
    Remarks: "Remarks",
    Attachment: "Attachment",
    report:"Report",
    delete: "Delete",
    batchdeletion: "Batch deletion",
    querybtn: "Query",
    resetbtn: "Reset",
    select_file: "Select file",
    export_data: "Export data",
    collect: "Collect",
    gather: "Gather",
    telemetry: "Telemetry",
    remote_signaling: "Remote signaling",
    constant_value: "Constant value",
    wireless: "Wireless",
    upgrade: "Upgrade",
    termination: "Termination",
    upload_program: "Upload program",
    upgrade_tatus: "Upgrade Status",
    real_time_refresh_of_upgrade_progress: "Real time refresh of upgrade progress",
    upgrade_progress: "Upgrade progress",
    total_frames: "Total frames",
    has_been_sent: "Has been sent",
    continued_transmission: "Continued transmission",
    log: "Log",
    fixed_value_log: "Fixed value log",
    upgrade_log: "Upgrade log",
    application_type: "Application type",
    program_version: "Program version",
    program: "Program",
    file_size: "File size",
    associated_account: "Associated account",
    project_affiliation: "Project affiliation",
    province_city: "Province/City",
    detailed_address: "Detailed address",
    line_topology_diagram: "Line topology diagram",
    only_one_file_can_be_uploaded: "Only one file can be uploaded",
    are_you_sure_to_continue_the_file_upgrade: "Are you sure to continue the file upgrade",
    please_wait_for_device_upgrade: "Issued, please wait for device upgrade",
    currently: "Currently",
    devices_have_been_selected: "devices have been selected",
    do_you_want_to_upgrade: "do you want to upgrade",
    please_select_at_least_one_device: "Please select at least one device",
    please_upload_the_upgrade_program: "Please upload the upgrade program",
    point_number_cannot_be_empty: "Point number cannot be empty",
    read_successfully: "Reading successful, please refresh the table (data will be updated within two minutes, if refresh is unsuccessful, please try again)",
    refresh_successful: "Refresh successful",
    please_read_and_refresh_the_data_before_presetting: "Please read and refresh the data before presetting",
    The_fixed_value_parameter_of_device: "The fixed value parameter of device",
    cannot_be_empty: "cannot be empty",
    Issued_to_device: "Issued to device",
    Time_synchronization: "Time synchronization",
    calibration_time: "Calibration time",
    read: "Read",
    settings: "Settings",
    Select_date_and_time: "Select date and time",
    heartbeat_time: "Heartbeat time (seconds)",
    Please_enter_the_heartbeat_time: "Please enter the heartbeat time",
    Total_call_time: "Total call time (minutes)",
    Please_enter_the_total_call_time: "Please enter the total call time",
    Update_Beidou_position: "Update Beidou position",
    Heartbeat: "1. Heartbeat and overall call are all system configurations.",
    Heartbeat2: "2. The default time for synchronization is the system time, and the selected time is used as the reference. The device defaults to all devices in the current account, and the selected device is used as the reference.",
    Corresponding_project: "Corresponding project",
    Substation_name: "Substation name",
    Location_updated_successfully: "Location updated successfully",
    Total_devices_under_current_account: "Total devices under the current account",
    location_update_successful: "location_update_successful",
    failure: "failure",
    total_progress: "total progress",
    The_value_cannot_be_empty: "The value cannot be empty",
    Please_enter_a_numerical_value: "Please enter a numerical value",
    Currently_all_devices_under_the_account: "Currently all devices under the account",
    Do_you_want_to_issue_timing_commands: "Do you want to issue timing commands",
    please_wait_for_the_device_to_synchronize: "Please wait for the device to synchronize",
    Setup_successful: "Setup successful",
    Determine_the_updated_Beidou_position: "Confirm to update the Beidou location of all devices under the current account",
    Get_all_devices: "Get all devices",
    Failed_to_retrieve_all_devices: "Failed to retrieve all devices",
    Update_completed: "Update completed",
    Project_Name: "Project Name",
    Are_you_sure_to_add_a_single_cable_device: "Are you sure to add a single cable device",
    Not_sent_reason: "Not sent, reason:",
    Manual_judgment: "Manual judgment",
    text_message: "Text message",
    Manually_processed: "Manually processed",
    Unprocessed_manually: "Unprocessed manually",
    Remarks_Results: "Remarks Results",
    It_is_unclear_whether_this_malfunction_has_occurred: "It is unclear whether this malfunction has occurred",
    Please_enter_content: "Please enter content",
    Please_enter_the_name_the_personnel: "Please enter the name the personnel",
    Please_select_the_remark_result: "Please select the remark result",
    Please_enter_the_processing_content: "Please enter the processing content",
    Fault_information: "Fault information",
    affiliated_group: "affiliated group",
    Fault_Type: "Fault Type",
    fault_time: "Fault time",
    Fault_file: "Fault file",
    Creation_Time: "Creation Time",
    manual_processing:"manual processing",
    handler:"handler",
    fault_line:"fault line",
    processing_time:"processing time",
    fault_location:"fault location",
    Fault_interval:"Fault interval",
    placeholder:"placeholder",
    fault_phase:"fault phase",
    and:"and",
    between:"between",
    process:"process",
    save:"save",
    Equipment_issuance:"Equipment issuance",
    Substation_topology_diagram:"Substation topology diagram",
    province:"province",
    Monday:"Monday",
    Tuesday:"Tuesday",
    Wednesday:"Wednesday",
    Thursday:"Thursday",
    Friday:"Friday",
    Saturday:"Saturday",
    Sunday:"Sunday",
    
    Notification_period:"Notification period",
    Start_time:"Start time",
    End_time:"End time",
    Select_a_time_range:"Select a time range",
    Personnel_number:"Personnel number",
    Please_enter_your_phone_number:"Please enter your phone number",
    Please_save_and_distribute_the_device:"Please save and distribute the device",
    Please_select_the_faulty_circuit:"Please select the faulty circuit",
    Please_select_the_faulty_phase:"Please select the faulty phase",

    Please_select_the_fault_interval:"Please select the fault interval",
    Issued_successfully:"Issued successfully",
    Please_enter_the_processor:"Please enter the processor",

    exportbtn: "Export",
    importbtn: "Import",
    realdatabtn: "Real time data",
    returnbtn: "Back",
    configuration: "Configuration",
    linelabel: "Circuit",
    daterangelab: "Date range",
    begindate: "Date commenced",
    enddate: "End date",
    devnamelab: "Name of the device",
    devnametit: "Please enter the device name",
    devwarnStatelab: "Alarm status",
    devwarnstateopton1: "No limit",
    devwarnstateopton2: "Restoration",
    devwarnstateopton3: "Action",
    emportsuccessmsg: "The export was successful",
    exportfailed: "The export was failed",
    substation: "Substation",
    nodatatit: "No data at present",
    addedsuccessful: "Added successful",
    modifiedsuccessful: "Modified successful",
    deletesuccessful: "Delete successful",
    savesuccessful: "Save successful",
    downloadsuccessful: "Download successful",
    refresh_cache: "Refresh configuration cache"
  },
  soevue: {
    soetable: {
      serial: "SN",
      warntime: "Alarm Time",
      linename: "Circuit",
      devname: "Name of the device",
      alarmcontent: "Alarm content"
    }
  },
  statistic: {
    year: "In the last one year",
    sixmonths: "In the last six months",
    onemonth: "In the last one month",
    week: "In the last one week",
    times: "times",
    faultanalysisstatistics: "Fault analysis statistics",
    faultanalysis: "The number of failures analyzed, the",
    accumulatedcount: "The cumulative number of failures",
    groundfault: "Ground fault",
    shortcircuitfault: "Short-circuit faults",
    outagefault: "Power failure",
    faultverification: "Failure verification statistics",
    groundingfaults: "The number of line ground faults",
    notverified: "Not verified",
    verified: "Verified"
  },
  statisticdevice: {
    exportonlinerate: "Exporting online rates",
    onexportbydevice: "Exporting device logs",
    equipmentonlinerate: "Equipment on-line rate (/times)",
    dataintegrityrate: "Data completeness rate (/%)",
    equipmentonlineratelist: "Equipment on-line rate List",
    onlineratetab: {
      archives_name: "Site name",
      device_name: "Type of equipment",
      onlinetime_max: "Maximum number of hours online",
      onlinetime_all: "Total number of hours online",
      offlinetime_max: "Maximum Offline duration",
      last_onlinetime: "Last login time",
      offlinetime_all: "Total offline hours",
      online_rate: "Online rate",
      online_count: "Online times"
    }
  },
  insulation: {
    table: {
      serial: "SN",
      linename: "Circuit",
      createtime: "Creation time",
      Insulationmessages: "Insulation warning messages"
    },
    insulationwarningrule: "Insulation warning--Rule configuration",
    dailyexceeding: "Daily exceeding",
    weeklyexceeding: "Weekly exceeding",
    monthlyexceeding: "Monthly exceeding",
    insulationwarningoccurs: "Grounding fault, insulation warning occurs"
  },
  report: {
    month: "Monthly report",
    week: "Weekly Report",
    date: "Journal",
    customdate: "Customizing the time period",
    PlatformName: "Fault locating systems",
    analysisreport: "Statistical analysis reports",
    group_name: "Changsha Hengdian Poly Energy Electronic Technology Co",
    basic: "Basic information",
    nickName: "Username",
    dateTypeText: "Type of report",
    statisticsdate: "Statistical time",
    currentDate: "Date of generation",
    format: "yyyy-MM-dd",
    format1: "yyyy WW week",
    format2: "yyyy-MM",
    lastweek: "In the last one week",
    lastmonth: "In the last one month",
    lastthreemonths: "In the last three month",
    analysisreport: "Analysis report"
  },
  smslog: {
    table: {
      serial: "SN",
      content: "SMS content",
      user_phones: "User telephones",
      sendstatus: "Send status",
      success: "Succeed",
      fail: "Fail",
      create_time: "Creation time"
    }
  },
  converting: {
    filterText: "Enter keywords for search",
    devform: {
      id: "Equipment ID",
      manufacturer: "Manufacturer",
      device_model: "Equipment model",
      longitude: "Longitude",
      software_version: "Software version",
      operation: "Operational or not",
      can_lb: "Record waves or not",
      notit: "False",
      yestit: "True",
      communication_port: "Communication ports",
      sim_iccid: "SIM card ICCID number",
      Main_sim_iccid: "Main sim iccid",
      Backup_sim_iccid: "Backup sim iccid",
      Main_MSISDN_card: "Main MSISDN card",
      Prepare_MSISDN_card: "Prepare MSISDN card",
      communication_type: "Type of communication",
      type1: "TCP clients",
      type2: "UDP clients",
      terminal_id: "Terminal ID",
      terminal_name: "Name of the terminal",
      name1: "Overhead transient recording type",
      name2: "Cable steady state recording type",
      device_type: "Type of equipment",
      devtype1: "Marginal sub-stations",
      devrype2: "Fault indicator",
      latitude: "Latitude",
      hardware_version: "Hardware version",
      str_link_addr: "Link address",
      linkaddrtit: "Hex",
      pointTable: "The point table",
      sim_ipaddr: "SIM card IP address",
      protocol_type: "Protocol type",
      protype1: "101 balanced mode",
      diagramcfg: "Wiring diagram configuration",
      leveltype: "Equipment level",
      lvl1: "Level I",
      lvl2: "Level II",
      lvl3: "Level Ⅲ",
      parent_location: "Device parent",
      tower: "Tower",
      sort: "Sort number",
      towercfg: "Tower configurations",
      front: "Front Pole Tower",
      after: "Rear Pole Tower",
      cablecfg: "Cable configuration",
      cabletype: "Cable type",
      cable1: "1 in 3 out",
      cable2: "2 in 4 out",
      cable3: "2 in 6 out",
      cablelist: "Cable List",
      linename: "Circuit",
      pointTableattribute: "Point table attribute"
    },
    placeholder: "Select",
    pointattr1: "Route ",
    pointattr2: "",
    linkaddrtit1: "Please enter the link address",
    linkaddrtit2: "Link address cannot exceed FFFF",
    parsetit: "parse error",
    teridtit: "Please enter the terminal ID",
    ternametit: "Please select a terminal name",
    devtypetit: "Please select the device type",
    comtypetit: "Please select communication type",
    protypetit: "Please select the protocol type",
    pointtit: "Please select a point table",
    simaddrtit: "The length does not exceed 16 characters",
    parenttit: "Please select the device parent level",
    sorttit: "Please select a sorting number",
    route2: "Route 2",
    route3: "Route 3",
    route4: "Route 4",
    route5: "Route 5",
    appendtitle: "Add",
    editortitle: "Edit",
    removetitle: "Are you sure you want to delete it?",
    removepc: "Tip",
    placeholder: "Please enter the name of the substation",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel",
    inputerrmsg: "Cannot be empty"
  },
  pointdot: {
    pointname: "The name of the point table",
    placeholder: "Please enter the name of the point table",
    placeholder1: "Please enter the unit",
    placeholder2: "Please enter the method multiplier",
    placeholder3: "Please enter the address",
    placeholder4: "Please upload the import file",
    table: {
      name: "The name of the point table",
      unit: "Unit",
      accuracy: "Method multiplier",
      straddr: "Address",
      inneraddr: "Internal address",
      create_time: "Creation time"
    },
    warningmsg: "Please select the data first",
    tic: "Tip",
    deletemsg: "After deletion, it cannot be restored. Are you sure you want to delete the selected data?",
    appendtitle: "Add",
    editortitle: "Edit",
    removetitle: "Are you sure you want to delete it?",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel",
    inputerrmsg1: "Cannot be empty",
    inputerrmsg2: "No special characters allowed",
    detailview: "Details page",
    mubtit: "Template",
    mubanemporttit: "Download and import the template",
    emportPointinfotit: "System internal point table information",
    importfilepathstit: "Upload the file",
    upload__text: "Drag the file here, or ",
    upload__text1: "click Upload",
    upload__tip: "Only XML file import is supported",
    uploaderror: "The upload file size cannot exceed 5MB!",
    uploaderror1: "File upload failed",
    uploadsuccess: "File upload successful",
    uploadwarning: "Currently limited to selecting 1 file",
    uploadmsg: "Are you sure you want to remove this file?",
    confirm_removal: "Confirm removal ",
  },
  verifyfault: {
    table: {
      serial: "SN",
      route_umber: "Route umber",
      archive_name: "Name of the line",
      fault_type: "Fault Type",
      fault_type1: "Ground fault",
      fault_type2: "Short-circuit faults",
      fault_type3: "Power failure",
      fault_typedesc: "Fault details",
      faultlocation: "Fault location",
      fault_time: "Fault time",
      verification_status: "Verification of results",
      verification_status1: "Errors of judgment",
      verification_status2: "Accuracy of judgment",
      verification_status3: "It is unclear whether this malfunction has occurred",
      handle_user_name: "Processors",
      handle_content: "Processing profiles",
      handle_time: "Processing time",
      handle_status: "Processing status",
      handle_status1: "untreated",
      handle_status2: "processed",
      handbtn: "Process",
      handimgbtn: "View attachments",
      imgtit: "Attachment Image Set",
      checkedNum: "Having processed the verification",
      noCheckedNum: "Verification of non-processing",
      editStatus: "The editor verifies the status of the",
      result: "Verification of results",
      result1: "Errors of judgment",
      result2: "Accuracy of judgment",
      handleInfo: "Handling situation",
      placeholder: "Please input the information found during on-site verification",
      placeholder1: "Please select the verification result",
      placeholder2: "Please enter the processing status",
      placeholder3: "Please select the processors",
      handler: "Processors",
      handlerimgs: "Upload the attachment",
      confirmbtn: "Confirm",
      cancelbtn: "Cancel",
      handsuccess: "Successfully processed"
    }
  },
  groupmanage: {
    gname: "Group name",
    placeholder: "Please enter the group name",
    placeholder1: "Please enter the platform name",
    placeholder2: "Please enter the SMS KeyID",
    placeholder3: "Please enter the SMS KeySecret",
    placeholder4: "Please enter your SMS signature",
    placeholder5: "Please enter the SMS template code",
    placeholder6: "Please upload the platform logo",
    table: {
      serial: "SN",
      group_name: "Group name",
      PlatformName: "Platform Name",
      SMSaccessKeyId: "SMS KeyID",
      SMSaccessKeySecret: "SMS KeySecret",
      SMSSignName: "SMS signature",
      SMSTemplateCode: "SMS template Code",
      create_time: "Creation time",
      platformLogo: "Platform logo"
    },
    tic: "Tip",
    appendtitle: "Add",
    editortitle: "Edit",
    removetitle: "Are you sure you want to delete it?",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel"
  },
  settingmanage: {
    serial: "SN",
    substation_name: "Substation name",
    is_use: "Is it enabled",
    select_tips: "Select",
    is_use0: "Disable",
    is_use1: "Enable",
    Status0: "Disable",
    Status1: "Enable",
    not_send_sms0: "Close",
    not_send_sms1: "Open",
    not_send_sms: "Whether to intercept or not",
    repeat_term: "Repeated interception period",
    create_time: "Creation time",
    repeat_term_af: "minutes within,repeat without sending",
    confirmbtn: "Sure",
    cancelbtn: "Cancel",
    enatit1: "Do you want to disable this configuration?",
    enatit2: "Do you want to enable this configuration?",
    opsuccess: "Operation successful",
    tic: "Tip"
  },
  usermanage: {
    serial: "SN",
    account: "Account",
    password: "Password",
    username: "Username",
    Role_name: "User Role",
    Group_name: "Affiliated groups",
    phone: "Cell phone number",
    Status: "User status",
    Status1: "All",
    Status2: "Normal",
    Status3: "Disable",
    Status4: "Enable",
    CreateTime: "Creation time",
    isUpdatemsg: "Change Password",
    checkedRoles: "Belonging role",
    isSmsPush: "SMS push",
    Region: "Own Region",
    all: "All",
    placeholder: "Please enter your account",
    placeholder1: "Please enter your username",
    placeholder2: "Please enter your phone number",
    placeholder3: "Please enter your password",
    placeholder4: "Format error, please enter the correct phone number",
    placeholder5: "Please enter the correct phone number",
    placeholder6: "Please select a role",
    placeholder7: "Password cannot be empty",
    placeholder8: "The password length must be greater than or equal to 6 digits",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel",
    tic: "Tip",
    deletetit: "Do you want to delete the user?",
    enatit1: "Do you want to disable this user?",
    enatit2: "Do you want to enable this user?",
    opsuccess: "Operation successful"
  },
  rolemanage: {
    serial: "SN",
    Name: "Role name",
    Group_name: "Affiliated groups",
    Status: "Status",
    Status1: "All",
    Status2: "Normal",
    Status3: "Disable",
    CreateTime: "Creation time",
    roleDesc: "Role Description",
    allocation1: "For role",
    allocation2: "Assigning menus",
    placeholder: "Please enter the role name",
    placeholder1: "Please enter a role description",
    placeholder2: "Cannot be empty",
    tic: "Tip",
    appendtitle: "Add",
    editortitle: "Edit",
    removetitle: "Are you sure you want to delete it?",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel",
    assginsuccess: "Allocation successful"
  },
  menusmanage: {
    name: "Menu name",
    parentName: "Parent menu",
    parentNamedata: "Root node",
    icon: "Icon",
    not: "No",
    sel: "Select",
    url: "Url address",
    sort: "Sort number",
    isShow: "Display or not",
    EnglishName: "English Name",
    placeholder: "Please enter the menu name",
    placeholder1: "Please enter the Url address",
    placeholder2: "Please enter the sorting number",
    tic: "Tip",
    removetitle: "Are you sure you want to delete it?",
    confirmbtn: "Confirm",
    cancelbtn: "Cancel"
  },
  feedback: {
    serial: "SN",
    uname: "Username",
    uphone: "Contact number",
    backcontent: "Feedback content",
    create_time: "Feedback time",
    handimgbtn: "View attachments",
    imgtit: "Attachment Image Set"
  },
  systemlog: {
    titlelab: "Title/Content",
    title: "Title",
    logType: "Log Type",
    AppName: "Application name",
    Content: "Log content",
    Uname: "Username",
    timespan: "Creation time",
    TraceId: "Link ID"
  },
  topovue: {
    toptitle: "Wiring topology diagram",
    RealRefresh: "Real-time refresh",
    savePosition: "Save location",
    savePositionmsg: "Successfully saved",
    nodata: "No data at present",
    closeChart: "Back",
    trendchart: "Point trend chart",
    generalcall: "Equipment general call",
    recordingfile: "Recording file",
    generaltimecs: "General call time of current data",
    GeneralCall: "Data general call",
    GetGeneralCall: "Data update",
    yc: "Telemetering",
    yx: "Telesignalling",
    fg: "Restoration",
    dz: "Action",
    Readfiles: "Read the recorded wave file",
    Preview: "Online preview",
    Downloadfiles: "Download to local",
    file_name: "The name of the document",
    file_addr: "The address of the document",
    read_state: "Read the status",
    read_state1: "Read failure",
    read_state2: "Read completed",
    read_time: "Reading time",
    recordchartcstit: "Equipment recording file analysis",
    GeneralCallmsg: "Calling for device data, please check the results in 1 minute",
    Readfilesmsg: "Reading the recorded wave file, please check the results in 3-5 minutes",
    Previewmsg1: "Please select at least one file data",
    Previewmsg2: "Only one file can be previewed at a time, please select one file data"
  },
  fault: {
    FaultAnalysisNotification: "Fault analysis notification"
  },
  alls: {
    home1: "Operation",
    hometit1: "Fault analysis notification",
    hometab1: "Fault moment",
    hometab2: "Fault substation",
    hometab3: "Fault line",
    hometab4: "Fault phase",
    hometab5: "Automatic judgment interval",
    hometab6: "Creation time",
    hometab7: "number of devices",
    hometab8: "System judgment",
    lines1: "Province/City",
    lines2: "Corresponding project",
    lines3: "Substation name",
    lines4: "Line name",
    lines4p: "Please enter the line name",
    linetopobtn1: "Equipment return",
    linetopobtn2: "Batch remote control",
    linetopodet1: "Fixed value parameter",
    linetopodet2: "Remote control settings",
    det1btn0: "Restart",
    det1btn1: "Device restart",
    det1btn2: "Read",
    det1btn3: "Switch",
    det1btn4: "Preset",
    det1btn5: "Welding",
    det1btn6: "Revoke",
    det1btn7: "Click to upload",
    det1btn8: "Read all",
    det1btn9: "Refresh table",
    det1int1: "Fixed value code",
    det1int2: "Maximum",
    det1int3: "Minimum",
    det1int4: "Point number",
    det1int5: "Type",
    det1int6: "Length",
    det1int7: "Value",
    det1tit0: "Fixed value point number",
    det1tit1: "Fixed value parameter",
    det1tit2: "Multiple parameters",
    det1tit3: "Fixed value parameter file",
    det1tit4: "Only XML files can be uploaded",
    det1tit5: "Single parameter",
    det1tit6: "Please enter hexadecimal data",
    det1tab1: "Parameter Address",
    det1tab2: "Parameter Name",
    det1tab3: "Parameter Content",
    det1tab4: "Unit",
    det1tab5: "Type",
    det2tit1: "Remote control",
    det2tit2: "Operable state",
    det2tit3: "Select status value",
    det2btn1: "Execute",
    soetit2: "Alarm content",
    soetitp2: "Please enter the alarm content",
    soetitp3: "Please enter the fixed value point number",
    soetitp4: "Please enter the fixed value parameter",
    soetab1: "Substation",
    equibtn1: "Export online logs",
    phonelogtab1: "Notification content",
    phonelogtab2: "Notification Status",
    subtit1: "Name",
    subtit2: "Input",
    subtit3: "Select"
  }
}
export default en
